(function($) {
    'use strict';

    function newContent($content) {

        if ($content == null || $content.length < 1) {
            return;
        }

        $content.each(function(i, element) {
            util.animationBlocker(element).blockForDelay();
            mtl.alloy.process(element);
        });

    }

    $.extend($.magnificPopup.defaults, {
        removalDelay: 300,
        callbacks: {

            ajaxContentAdded: function() {
                newContent(this.content);
            },

            change: function() {
                newContent(this.content);
            }

        }
    });

}(jQuery));
